import React from "react"
interface IIconProps {
    color?: string
}
const ChevronRightIcon = (props: IIconProps) => {
    const { color = '#888' } = props
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.59997 12.6H4.66664C4.48651 12.6 4.32224 12.4959 4.24477 12.3331C4.16731 12.1702 4.19111 11.9775 4.30544 11.8375L8.26371 6.99999L4.30544 2.16206C4.19111 2.02253 4.16777 1.82979 4.24477 1.66646C4.32177 1.50313 4.48651 1.39999 4.66664 1.39999H5.59997C5.73997 1.39999 5.87251 1.46299 5.96117 1.57126L10.1612 6.70459C10.3016 6.87679 10.3016 7.12366 10.1612 7.29586L5.96117 12.4292C5.87251 12.537 5.73997 12.6 5.59997 12.6Z" fill={color} />
        </svg>
    )
}

export default ChevronRightIcon
